document.addEventListener('DOMContentLoaded',function(){
  var cards=[].slice.call(document.querySelectorAll('.ss-card'));
  var active=null;
  function soundName(card){
    var heading=card.querySelector('.ss-card__meta h3');
    return heading ? heading.textContent.trim() : 'sound';
  }
  function reset(card){
    var audio=card.querySelector('audio');
    var button=card.querySelector('[data-ss-play]');
    var label=card.querySelector('[data-ss-label]');
    var progress=card.querySelector('[data-ss-progress]');
    if(!audio||!button)return;
    audio.pause();
    button.setAttribute('aria-pressed','false');
    button.setAttribute('aria-label','Play audio preview of '+soundName(card));
    if(label)label.textContent='Play preview';
    if(progress)progress.style.width='0%';
    if(active===card)active=null;
  }
  cards.forEach(function(card){
    var audio=card.querySelector('audio');
    var button=card.querySelector('[data-ss-play]');
    var progress=card.querySelector('[data-ss-progress]');
    var label=card.querySelector('[data-ss-label]');
    if(!audio||!button||!progress)return;
    button.addEventListener('click',function(){
      if(active===card&&!audio.paused){reset(card);return;}
      if(active)reset(active);
      active=card;
      audio.currentTime=0;
      button.setAttribute('aria-pressed','true');
      button.setAttribute('aria-label','Pause audio preview of '+soundName(card));
      if(label)label.textContent='Pause preview';
      var promise=audio.play();
      if(promise&&promise.catch)promise.catch(function(){reset(card);});
    });
    audio.addEventListener('timeupdate',function(){
      var duration=audio.duration||30;
      progress.style.width=Math.min(100,(audio.currentTime/duration)*100)+'%';
    });
    audio.addEventListener('ended',function(){reset(card);});
    audio.addEventListener('error',function(){reset(card);});
  });
});
